export default __webpack_public_path__ + "static/media/Aragon.f49ddc75.png";